import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '../../shared/fi-backend/fi-backend.service';
import { ContentLanguagesService } from '../../utilities/fi-services/content-languages.service';
import { ExtendedRoleRightModel, IExtendedRoleRightModel } from '../extended-role-right.model';
import { ModuleType } from '../../shared/types/module-type';
import { OperationOverlayLargeNg4Service } from '../../utilities/operation-overlay-large/operation-overlay-large.service';
import { AuthenticateService } from '../../utilities/fi-services/authenticate.service';
import { IFiUserData } from '../../shared/fi-shared-services/fi-user-data.service';
import { isEqual } from '../../shared/utils';
import { IRoleRelations } from '../role';
import { ILightWeightObject } from '@fi-app/shared/models';

@Injectable()
export class ExtendedRoleRightService {
    constructor(
        private fiBackend: FiBackendService,
        private contentLanguagesService: ContentLanguagesService,
        private operationOverlayLargeService: OperationOverlayLargeNg4Service,
        private authenticateService: AuthenticateService,
        private injector: Injector,
    ) {}

    /*GetExtendedRoleRight(id: number) {
        return new Promise<ExtendedRoleRightModel>((resolve, reject) => {
            const extendedRoleRight = new ExtendedRoleRightModel();

            if (id > 0) {
                this.fiBackend.fetchData<IExtendedRoleRightModel>(`Core/ExtendedRoleRight/GetExtendedRoleRight/${id}`).then((response) => {
                    extendedRoleRight.Initialize(response);
                    extendedRoleRight.InitializeExtendedRoleRightContentLanguages(this.injector, response);

                    resolve(extendedRoleRight);
                }, () => {
                    reject();
                });
            } else {
                extendedRoleRight.InitializeExtendedRoleRightContentLanguages(this.injector);

                resolve(extendedRoleRight);
            }
        });
    }*/

    /*    GetExtendedRoleRightByRoleId(roleId, moduleType = ModuleType.Core) {
        return new Promise<ExtendedRoleRightModel>((resolve, reject) => {
            this.fiBackend.fetchData<IExtendedRoleRightModel>(`Core/ExtendedRoleRight/GetExtendedRoleRight/${roleId}/${moduleType}`).then((response) => {
                if (response) {
                    const extendedRoleRight = new ExtendedRoleRightModel(response);
                    extendedRoleRight.ModuleType = moduleType;
                    extendedRoleRight.InitializeExtendedRoleRightContentLanguages(this.injector, response);
                    resolve(extendedRoleRight);
                } else {
                    resolve(undefined);
                }
            }, reject);
        })
    }*/

    GetLightWeightRoles(id, moduleType) {
        return this.fiBackend.fetchData<ILightWeightObject[]>(
            `Core/ExtendedRoleRight/GetLightWeightRoles/${id || 0}/${moduleType}`,
        );
    }

    /*SaveExtendedRoleRight(extendedRoleRight) {
        //Creating a new object because it looks bad in the GUI otherwise.
        const extendedRoleRightApiModel = JSON.parse(JSON.stringify(extendedRoleRight));

        const promise = new Promise<number>((resolve, reject) => {
            //Remove the rights that's not checked
            if (extendedRoleRightApiModel.RoleApplicationSettings) {
                extendedRoleRightApiModel.RoleApplicationSettings.forEach(function (item) {
                    if (!item.Checked)
                        extendedRoleRightApiModel.RoleApplicationSettings.splice(extendedRoleRightApiModel.RoleApplicationSettings.indexOf(item), 1);
                });
            }

            this.fiBackend.fetchDataPost<number>("Core/ExtendedRoleRight/SaveExtendedRoleRight", extendedRoleRightApiModel).then((response) => {
                resolve(response);
            }, reject);
        });

        return promise;
    };*/

    /*DeleteExtendedRoleRights(extendedRoleRightIdsToDelete) {
        return this.fiBackend.fetchDataPost(
            "Core/ExtendedRoleRight/DeleteExtendedRoleRights", extendedRoleRightIdsToDelete);
    }*/

    getRoleRelations(roleId) {
        return this.fiBackend.fetchData('Core/ExtendedRoleRight/GetRoleRelations/' + roleId);
    }

    saveRoleRelations(roleRelations: IRoleRelations) {
        return this.fiBackend.fetchDataPost('Core/ExtendedRoleRight/SaveRoleRelations', roleRelations);
    }

    extendedAccessRightsModel = null;

    closeExtendedAccessSession() {
        this.authenticateService
            .CloseExtendedAccessSession()
            .then((data) => this.onSwitchExtendedAccessSessionSuccess(data));
    }

    validateSelectedAccessRights(selectedAccessRights) {
        const isInvalid =
            isEqual(
                selectedAccessRights.AccessRightCoreFilter.RoleIds,
                this.extendedAccessRightsModel.AccessRightCoreFilter.RoleIds,
            ) &&
            isEqual(
                selectedAccessRights.AccessRightCoreFilter.BusinessAreaIds,
                this.extendedAccessRightsModel.AccessRightCoreFilter.BusinessAreaIds,
            ) &&
            isEqual(
                selectedAccessRights.AccessRightCoreFilter.AreaIds,
                this.extendedAccessRightsModel.AccessRightCoreFilter.AreaIds,
            ) &&
            isEqual(
                selectedAccessRights.AccessRightCoreFilter.BusinessUnitIds,
                this.extendedAccessRightsModel.AccessRightCoreFilter.BusinessUnitIds,
            ) &&
            isEqual(
                selectedAccessRights.AccessRightCoreFilter.ClusterIds,
                this.extendedAccessRightsModel.AccessRightCoreFilter.ClusterIds,
            ) &&
            isEqual(
                selectedAccessRights.AccessRightUserFilter.UserIds,
                this.extendedAccessRightsModel.AccessRightUserFilter.UserIds,
            );

        return !isInvalid;
    }

    // note: not used ?
    onSwitchExtendedAccessSessionSuccess(data: IFiUserData) {
        /*this.sessionService.extendData({
            Token: data.TokenId,
            SessionExpire: data.SessionExpire,
            Authorized: true
        });
        const user = this.userDataService.getUserData();
        user.FullName = data.FullName;
        user.UserId = data.UserId;
        user.BusinessUnitName = data.BusinessUnitName;
        user.BusinessUnitId = data.BusinessUnitId;
        user.UserEmail = data.UserEmail;
        user.UserPhone = data.UserPhone;
        user.PreferredContentLanguage = data.PreferredContentLanguage;
        user.ApplicationLanguage = data.ApplicationLanguage

        this.authenticateService.GetModuleAccessRights().then((data) => {
            this.sessionService.setUserModuleAccessRights(data);
            this.sessionService.syncSession();
            window.location.reload();
        });  todo functionality has been commented out */
    }

    onExtendedAccessRightsSelected(selectedAccessRights) {
        if (!this.validateSelectedAccessRights(selectedAccessRights)) return;

        this.authenticateService
            .SetupExtendedAccessSession(selectedAccessRights)
            .then((data) => this.onSwitchExtendedAccessSessionSuccess(data));
    }
}
